import {
  ShiftElementResponse,
  ShiftElementResponseItem
} from '@/types/service-response'
import moment from 'moment'
import { AutomaticallyPlannedEmployee } from '@/model/planning/AutomaticallyPlannedEmployee'
import { EditShiftPlan } from '@/model/planning/EditShiftPlan'
import { ShiftEmployeeDetails } from '@/model/planning/ShiftEmployeeDetails'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'

export class EmployeePlaceholder {
  private constructor (
    readonly number: number,
    readonly employeeId: number | undefined,
    readonly fullName: string,
    readonly kapacity: string | undefined,
    readonly competence: string,
    readonly education: string,
    readonly taskId: number | undefined,
    readonly taskName: string | undefined,
    readonly isFloater: boolean,
    readonly note: string | undefined,
    readonly isPlaceholder: boolean,
    readonly startDate: Date,
    readonly endDate: Date,
    readonly planningGroupName: string | undefined,
    readonly projectId?: number | undefined,
    readonly detailID?: number | undefined
  ) {}

  // public get isPlaceholder (): boolean {
  //   return true
  // }

  public static createListFromResponse (data: ShiftElementResponse, planningGroupList: PlanningGroup[]): Array<EmployeePlaceholder> {
    return data.map((item: ShiftElementResponseItem) => {
      const startDate = moment().hours(item.hourStart).minutes(item.minStart)
      const tempStart = moment().hours(item.hourStart).minutes(item.minStart)
      const endDate = tempStart.add(item.hourDauer, 'h').add(item.minDauer, 'm')
      const planningGroup: PlanningGroup | undefined = planningGroupList.find((i: PlanningGroup) => item.Planungsgruppe === i.planningGroup)

      return new EmployeePlaceholder(
        item.Zeile,
        item.MitarbeiterID || undefined,
        item.Name,
        item.Kapazitat && item.Kapazitat.trim().length && item.Kapazitat || undefined,
        item.Kompetenz || '',
        item.Bildung,
        item.ArbeitID || undefined,
        item.Arbeit && item.Arbeit.trim().length && item.Arbeit || undefined,
        item.springer,
        item.NotizElement && item.NotizElement.trim().length && item.NotizElement || undefined,
        true,
        startDate.toDate(),
        endDate.toDate(),
        planningGroup ? planningGroup.planningGroupName : undefined,
        item.ProjectSerie ? item.ProjectSerie : undefined
      )
    })
  }

  public static createFromEmployeePlanningResponseItem (item: any, planningGroupList: PlanningGroup[]): EmployeePlaceholder {
    //const startDate = moment().hours(item.hourStart).minutes(item.minStart)
    //const tempStart = moment().hours(item.hourStart).minutes(item.minStart)
    //const endDate = tempStart.add(item.hourDauer, 'h').add(item.minDauer, 'm')
    const planningGroup: PlanningGroup | undefined = planningGroupList.find((i: PlanningGroup) => item.Planungsgruppe === i.planningGroup)

    return new EmployeePlaceholder(
      item.Zeile,
      item.MitarbeiterID || undefined,
      item.Name,
      item.Kapazitat && item.Kapazitat.trim().length && item.Kapazitat || undefined,
      item.Kompetenz || '',
      item.Bildung,
      item.ArbeitID || undefined,
      item.Arbeit && item.Arbeit.trim().length && item.Arbeit || undefined,
      item.springer,
      item.NotizElement && item.NotizElement.trim().length && item.NotizElement || undefined,
      true,
      item.startDate,
      item.endDate,
      planningGroup ? planningGroup.planningGroupName : undefined,
      item.ProjectSerie ? item.ProjectSerie : undefined,
      item.detailID ? item.detailID : undefined
    )
  }

  public static createEmployeePlaceholderList (plannedEmployeeList: Array<AutomaticallyPlannedEmployee | EmployeePlaceholder>, placeholderList: Array<AutomaticallyPlannedEmployee | EmployeePlaceholder>): Array<EmployeePlaceholder> {

    let EmployeePlaceholderList: Array<EmployeePlaceholder> = []

    plannedEmployeeList.forEach((item: AutomaticallyPlannedEmployee | EmployeePlaceholder) => {
      if (!item.employeeId) {
        const placeholder = placeholderList.find((i: AutomaticallyPlannedEmployee | EmployeePlaceholder) => i.number === item.number)

        EmployeePlaceholderList.push(
          new EmployeePlaceholder(
            item.number,
            item.employeeId,
            'Avatar',
            item.kapacity,
            placeholder ? placeholder.competence : item.competence,
            placeholder ? placeholder.education : item.education,
            item.taskId,
            item.taskName,
            item.isFloater,
            item.note,
            item.isPlaceholder,
            item.startDate,
            item.endDate,
            placeholder ? placeholder.planningGroupName : undefined,
            item.projectId,
            item.detailID
          )
        )
      }
    })

    return EmployeePlaceholderList

  }

  public static createEmployeePlaceholderListFromEditShift (editShift: EditShiftPlan, placeholderList: Array<AutomaticallyPlannedEmployee | EmployeePlaceholder>, planningGroupList: PlanningGroup[]): Array<EmployeePlaceholder> {
    let EmployeePlaceholderList: Array<EmployeePlaceholder> = []

    placeholderList.forEach((item: EmployeePlaceholder) => {
      const detail: ShiftEmployeeDetails | undefined = editShift.details.find((i: ShiftEmployeeDetails) => i.row === item.number)
      if(detail && !detail.employeeId) {
        const planningGroup: PlanningGroup | undefined = planningGroupList.find((pg: PlanningGroup ) => pg.planningGroup === detail.planningGroup)
        EmployeePlaceholderList.push(
          new EmployeePlaceholder(
            item.number,
            item.employeeId,
            'Avatar',
            item.kapacity,
            item.competence,
            item.education,
            detail.taskId ? detail.taskId : item.taskId,
            item.taskName,
            item.isFloater,
            detail.note ? detail.note : undefined,
            item.isPlaceholder,
            detail.dateStart ? new Date(detail.dateStart) : item.startDate,
            detail.dateEnd ? new Date(detail.dateEnd) : item.endDate,
            planningGroup ? planningGroup.planningGroupName : item.planningGroupName,
            item.projectId,
            detail.detailId ? detail.detailId : item.detailID
          )
        )
      }
    })

    return EmployeePlaceholderList

  }

}
